import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba43ea9c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba43ea9c')) {
      api.createRecord('ba43ea9c', component.options)
    } else {
      api.reload('ba43ea9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ba43ea9c&", function () {
      api.rerender('ba43ea9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LinkInstructions/index.vue"
export default component.exports